import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './Login';
import RoleSelection from './RoleSelection';
import RegisterAdmin from './RegisterAdmin'; 
import RegisterCustomer from './RegisterCustomer';    
import Dashboard from './Dashboard';
import UserManagement from './UserManagement';
import UserDashboard from './UserDashboard';
import ElectronicOrder from './ElectronicOrder';
import PlasticOrder from './PlasticOrder';
import SolarOrder from './SolarOrder';
import AgroOrder from './AgroOrder';
import BatteryOrder from './BatteryOrder';
import OilOrder from './OilOrder';
import AdminOrders from './AdminOrders';
import QRManagement from './QRManagement';
import CustomerVerify from './CustomerVerify';
import CoPartner from './CoPartner';  
import PartnerDashboard from './PartnerDashboard';
import CoPartnerScan from './CoPartnerScan';
import ForgotPassword from './ForgotPassword';
import { AuthProvider } from './AuthContext';
import ProtectedRoute from './ProtectedRoute'; 
import FeedbackPage from './FeedbackPage'; 
import ProductRegistration from './ProductRegistration';
import AdminProductView from './AdminProductView'; 
import DirectVerify from './DirectVerify';
import ProRegister from './ProRegister';
import WasteRegister from './WasteRegister';
import PiboRegister from './PiboRegister';
import AuthorityRegister from './AuthorityRegister';
import PDFGenerator from './PDFGenerator';
import AuthorityDashboard from './AuthorityDashboard';
import RecyclerDashboard from './RecyclerDashboard';
import MapComponent from './MapComponent';


function App() {
  return (
    <AuthProvider>
    <Router>
      <Routes>
        {/* --- PUBLIC ROUTES --- */}
        <Route path="/" element={<Login />} />
        <Route path="/select-role" element={<RoleSelection />} />
        <Route path="/register-admin" element={<RegisterAdmin />} />
        <Route path="/register-customer" element={<RegisterCustomer />} />
        <Route path="/verify-product" element={<CustomerVerify />} />
        <Route path="/direct-verify" element={<DirectVerify />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />

        {/* --- PROTECTED ROUTES (Role-based Protection) --- */}
        
        {/* 1. Admin */}
        <Route path="/dashboard" element={<ProtectedRoute allowedRole="ADMIN"><Dashboard /></ProtectedRoute>} />
        <Route path="/user-management" element={<ProtectedRoute allowedRole="ADMIN"><UserManagement /></ProtectedRoute>} />
        <Route path="/admin-orders" element={<ProtectedRoute allowedRole="ADMIN"><AdminOrders /></ProtectedRoute>} />
        <Route path="/qr-management" element={<ProtectedRoute allowedRole="ADMIN"><QRManagement /></ProtectedRoute>} />
        <Route path="/co-partner" element={<ProtectedRoute allowedRole="ADMIN"><CoPartner /></ProtectedRoute>} />
        <Route path="/admin-feedback" element={<ProtectedRoute allowedRole="ADMIN"><FeedbackPage /></ProtectedRoute>} />
        <Route path="/admin-products" element={<ProtectedRoute allowedRole="ADMIN"><AdminProductView /></ProtectedRoute>} />
        <Route path="/Pdf-generator" element={<ProtectedRoute allowedRole="ADMIN"><PDFGenerator /></ProtectedRoute>} />

        {/* NEW MULTI-STEP UNIFIED REGISTRATION LANES */}
        <Route path="/register-pro" element={<ProRegister />} />     
        <Route path="/register-waste" element={<WasteRegister />} />
        <Route path="/register-pibo" element={<PiboRegister />} />
        <Route path="/register-authority" element={<AuthorityRegister />} />


        {/* 2. Customer */}
        <Route path="/user-dashboard" element={<ProtectedRoute allowedRole="CUSTOMER"><UserDashboard /></ProtectedRoute>} />
        <Route path="/electronic-order" element={<ProtectedRoute allowedRole="CUSTOMER"><ElectronicOrder /></ProtectedRoute>} />
        <Route path="/plastic-order" element={<ProtectedRoute allowedRole="CUSTOMER"><PlasticOrder /></ProtectedRoute>} />
        <Route path="/solar-order" element={<ProtectedRoute allowedRole="CUSTOMER"><SolarOrder /></ProtectedRoute>} />
        <Route path="/agro-order" element={<ProtectedRoute allowedRole="CUSTOMER"><AgroOrder /></ProtectedRoute>} />
        <Route path="/battery-order" element={<ProtectedRoute allowedRole="CUSTOMER"><BatteryOrder /></ProtectedRoute>} />
        <Route path="/oil-order" element={<ProtectedRoute allowedRole="CUSTOMER"><OilOrder /></ProtectedRoute>} />
        <Route path="/product-registration" element={<ProtectedRoute allowedRole="CUSTOMER"><ProductRegistration /></ProtectedRoute>} />
        <Route path="/authority-dashboard" element={<ProtectedRoute allowedRole="CUSTOMER"><AuthorityDashboard /></ProtectedRoute>} />

        {/* 3. Co-partner */}
        {/* 3. Co-partner */}
        <Route path="/partner-dashboard" element={<ProtectedRoute allowedRole="PARTNER, CUSTOMER"><PartnerDashboard /></ProtectedRoute>} />
        <Route path="/co-partner/scan" element={<ProtectedRoute allowedRole="PARTNER, CUSTOMER"><CoPartnerScan /></ProtectedRoute>} />

        {/* 4. Recycler Facility */}
        <Route path="/recycler-dashboard" element={<ProtectedRoute allowedRole="CUSTOMER"><RecyclerDashboard /></ProtectedRoute>} />


        <Route path="/search-on-map" element={<MapComponent />} />
         
      </Routes>
    </Router>
    </AuthProvider>
  );
}

export default App;